interface CurrentUser {
    aam: boolean;
    customerName: string;
    customerCanDemo: boolean;
    customerId?: number;
    formattedName: string;
    name?: string;
    redirect?: string;
    username: string;
    isBetaUser?: boolean;
    isBetaMode: boolean;
    email?: string;
}

export const CurrentUserDefaultState: CurrentUser = {
    aam: false,
    customerName: '',
    customerCanDemo: false,
    formattedName: '',
    username: '',
    isBetaMode: false,
};

export interface CreateUserModel {
    username: string;
    password: string;
    invite_code: string;
}

export interface TeamMemberModel {
    id: number;
    email: string;
    username: string;
    admin?: boolean;
    customer_id: number;
    created_at: string;
    updated_at: string;
    is_beta_user?: boolean;
    role: UserRole;
}

export enum CustomerId {
    Aampe = 1,
    Intelycare = 1099,
    Zalora = 1026,
    PayU = 1145,
    MrD = 1282,
    theCut = 1342,
    JoeCoffee = 2517,
}

export interface UserStatusModel {
    campaign_created: boolean;
    campaign_activated: boolean;
    formula_created: boolean;
    app_events_enabled: boolean;
    goal_created: boolean;
    dataset_created: boolean;
    offerings_created: boolean;
    value_propositions_created: boolean;
}

export enum UserPermissions {
    READ = 'read',
    WRITE = 'write',
    ADMIN = 'admin',
    CREATE = 'create',
    CREATE_FORMULA = 'create_formula',
    UPDATE = 'update',
    ARCHIVE = 'archive',
    DELETE = 'delete',
    GRANT_ACCESS = 'grant_access',
    REMOVE_ACCESS = 'remove_access',
    CONDITIONAL_UPDATE = 'conditional_update',
}

export enum UserRole {
    READER = 'Reader',
    MANAGER = 'Manager',
    ADMIN = 'Admin',
    EDITOR = 'Editor',
}

export enum UserSessionStatus {
    LOADING = 'loading',
    AUTHENTICATED = 'authenticated',
    UNAUTHENTICATED = 'unauthenticated',
}

export interface UserRoleFlags {
    isReadUser: boolean;
    hasWriteAccess: boolean;
    isAdmin: boolean;
    status: UserSessionStatus;
    hasDeleteAccess: boolean;
    hasCreateFormulaAccess: boolean;
}

export interface EntityPermissionBasedFlags extends UserRoleFlags {
    hasWriteOrCreateAccess: boolean;
}

export interface EntityPermissionUsers {
    id: number;
    email: string;
    role: UserRole;
    username: string;
    full_name?: string;
}
